export const SUPPRESS_SEARCH_EVENT_KEY = 'suppressSearchEventOnce';

export const markSearchEventSuppressed = (): void => {
  sessionStorage.setItem(SUPPRESS_SEARCH_EVENT_KEY, 'true');
};

export const consumeSuppressedSearchEvent = (): boolean => {
  if (sessionStorage.getItem(SUPPRESS_SEARCH_EVENT_KEY) === 'true') {
    sessionStorage.removeItem(SUPPRESS_SEARCH_EVENT_KEY);
    return true;
  }
  return false;
};
